import { Navigate, Outlet, useSearchParams } from 'react-router-dom'
import { parseToken } from 'helpers/auth'
import style from './RevivalWrapper.module.scss'

const RevivalWrapper = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const { adhesionId, lang } = (token ? parseToken(token) : null) || {}

  return lang && adhesionId
  ? (
    <div className={style.bg}>
      <div>
        <Outlet context={{adhesionId, lang, token}} />
      </div>
    </div>
  )
  : <Navigate to={'/sign-in'} />
}

export default RevivalWrapper